import React, {useEffect, useRef} from 'react';

const SCRIPT_ID = 'cloudflare-turnstile-script';

const loadTurnstileScript = () => {
  if (document.getElementById (SCRIPT_ID)) return;

  const script = document.createElement ('script');
  script.id = SCRIPT_ID;
  script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
  script.async = true;
  script.defer = true;
  document.body.appendChild (script);
};

const Turnstile = ({onVerify, onExpire, onError, resetSignal}) => {
  const containerRef = useRef (null);
  const widgetIdRef = useRef (null);
  const siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY;

  useEffect (() => {
    loadTurnstileScript ();

    const renderWidget = () => {
      if (!siteKey || !window.turnstile || !containerRef.current || widgetIdRef.current) {
        return;
      }

      widgetIdRef.current = window.turnstile.render (containerRef.current, {
        sitekey: siteKey,
        callback: token => onVerify && onVerify (token),
        'expired-callback': () => onExpire && onExpire (),
        'error-callback': () => onError && onError (),
      });
    };

    const interval = setInterval (() => {
      renderWidget ();
      if (widgetIdRef.current) clearInterval (interval);
    }, 250);

    return () => clearInterval (interval);
  }, [siteKey, onVerify, onExpire, onError]);

  useEffect (() => {
    if (window.turnstile && widgetIdRef.current) {
      window.turnstile.reset (widgetIdRef.current);
    }
  }, [resetSignal]);

  if (!siteKey) {
    return (
      <div className="alert alert-warning" role="alert">
        Turnstile site key is not configured.
      </div>
    );
  }

  return <div ref={containerRef} />;
};

export default Turnstile;
